// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "3fc524f48a05cb5b0dcf0b1984698e61f4de4072/static/css/" + chunkId + "." + {"725":"84c1fc5e","831":"583e16c7","854":"36854e5e"}[chunkId] + ".chunk.css";
};